import React from "react";
import { F, CLSNAME } from "../data/aircraft";
import { STATS } from "../data/stats";
import { fmtH, seatsTxt } from "../lib/engine";
import { Picture, Price } from "../lib/icons";

export default function AircraftTile({ code, g, onClick }) {
  const f = F[code];
  const st = STATS[code] || { n: 0 };
  const engineTxt = f.k === "balloon" ? "Experience" : (f.tw ? "Twin" : f.eng && f.eng.startsWith("3") ? "Three" : "Single") + " engine";
  const line3 = g ? (
    <div className="t3"><b>~{fmtH(g.block)}</b> {g.stops ? `with ${g.stops} fuel stop${g.stops > 1 ? "s" : ""}` : "nonstop"}</div>
  ) : (
    <div className="t3">{f.r ? <><b>{f.r.toLocaleString("en-IN")} nm</b> range · <b>{f.s} kt</b></> : "Sunrise flights"}</div>
  );
  return (
    <button className="tile" type="button" onClick={onClick} aria-label={`${f.n}, ${CLSNAME[f.c]}`}>
      <div className="pic">
        <Picture code={code} />
        {g && g.badge ? <span className="badge">{g.badge}</span> : null}
        <span className="fit">{seatsTxt(code)}</span>
      </div>
      <div className="t1"><span>{f.n}</span><Price tier={f.t} /></div>
      <div className="t2">{CLSNAME[f.c]} · {engineTxt}{f.pr ? " · Pressurised" : ""}</div>
      <div className="t2">{st.n} in India's charter fleet</div>
      {line3}
    </button>
  );
}
